module.exports = __webpack_public_path__ + "static/media/diamonds.9adb25c1.svg";